<template>
  <div>
    <back-btn />
    <v-container>
      <v-row>
        <v-col
          lg="3"
          md="4"
          sm="6"
          v-for="(item, i) in activities"
          v-bind:key="i"
        >
          <v-card class="card--shadow" @click="viewEachActivity(item.link)">
            <v-card-text>
              <h3 class="header_text">{{ item.text }}</h3>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BackBtn from "@/components/navigation/BackBtn";
export default {
  components: { BackBtn },
  data: () => ({
    activities: [
      { link: "he", text: "HE" },
      { link: "home-visit", text: "Home Visit" },
      { link: "supervision-visit", text: "Supervision Visit" },
      { link: "counseling", text: "Counseling" },
    ],
  }),
  methods: {
    viewEachActivity(linkName) {
      this.$router.push({
        name: linkName,
        params: {
          month: this.$route.params.month,
          year: this.$route.params.year,
          township_id: this.$route.params.township_id,
        },
        query: { township_id: this.$route.query.township },
      });
    },
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 10px;
}
h3 {
  text-align: center;
}
.header_text {
  color: var(--primary-color);
  letter-spacing: 1px;
}
</style>
